export const GET_USERS = "GET_USERS";
export const EDIT_USER = "EDIT_USER";
export const DELETE_USER = "DELETE_USER";
export const GET_USER_BY_ID = "GET_USER_BY_ID";
export const SET_USER_TO_NULL = "SET_SUPPLIER_TO_NULL";
